import gql from "graphql-tag";

export const CREATE_COVERAGE_MAPPING = gql`
  mutation AddCoverageMapping($data: CoverageMappingDataInput) {
    addCoverageMapping(data: $data) {
      id
    }
  }
`;

export const UPDATE_COVERAGE_MAPPING = gql`
  mutation UpdateCoverageMapping(
    $where: CoverageMappingWhereInput
    $data: CoverageMappingDataInput
  ) {
    updateCoverageMapping(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_COVERAGE_MAPPING = gql`
  mutation DeleteCoverageMapping($where: CoverageMappingWhereInput) {
    deleteCoverageMapping(where: $where) {
      id
    }
  }
`;

const coverageMappings = {
  CREATE_COVERAGE_MAPPING,
  UPDATE_COVERAGE_MAPPING,
  DELETE_COVERAGE_MAPPING,
};

export default coverageMappings;
